import cloudApi from '../services/cloudApi';

// Shared formatting for OAuth "connected app" grants — used by the Integrations
// Claude card and the admin MCP page's ConnectedApps list, so the two can't drift.

export const formatGrantDate = (dateString) => {
  const date = cloudApi.toLocalDate ? cloudApi.toLocalDate(dateString) : new Date(dateString);
  if (!date || Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
};

export const grantScopeLabel = (scopes) =>
  Array.isArray(scopes) && scopes.length === 1 && scopes[0] === 'read' ? 'Read-only' : 'Full access';
